import { BiSolidEditAlt } from 'react-icons/bi';
import { FaEye, FaTrashAlt } from 'react-icons/fa';
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { Permissions } from '../../../types/permissions';

const RolePermissionTableRow = ({
  permissions,
}: {
  permissions: Array<Permissions>;
}) => {
  // rendering role permission table row component here
  return (
    <div className='flex items-center justify-center gap-2'>
      {!permissions.length ? (
        <span title='No Permissions'>
          <FaMinus className='size-4' />
        </span>
      ) : (
        <>
          {permissions.includes('CREATE') && (
            <span title='Create'>
              <FaPlus className='size-4 hover:text-base-purple duration-300 cursor-pointer' />
            </span>
          )}

          {permissions.includes('READ') && (
            <span title='Read'>
              <FaEye className='size-4 hover:text-base-cyan duration-300 cursor-pointer' />
            </span>
          )}

          {permissions.includes('UPDATE') && (
            <span title='Update'>
              <BiSolidEditAlt className='size-4 hover:text-base-light-blue duration-300 cursor-pointer' />
            </span>
          )}

          {permissions.includes('DELETE') && (
            <span title='Delete'>
              <FaTrashAlt className='size-4 hover:text-base-red duration-300 cursor-pointer' />
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default RolePermissionTableRow;
